import * as THREE from "three";
import Experience from "./Experience.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

export default class Camera {
  constructor() {
    this.experience = new Experience();
    this.sizes = this.experience.sizes;
    this.scene = this.experience.scene;
    this.canvas = this.experience.canvas;
    this.debug = this.experience.debug;

    // Debug
    if (this.debug.active) {
      this.debugFolder = this.debug.ui.addFolder("camera");
    }

    this.defaultPositionCamera = new THREE.Vector3(0, 1, 6);

  

    this.setInstance(); 
    this.setOrthographic();

    this.is2DView = false; 
    this.setControls(); 
  }

  // Vue perspective (normale)
  setInstance() {
    this.instance = new THREE.PerspectiveCamera(
      55,
      this.sizes.width / this.sizes.height,
      0.1,
      20
    );
    this.instance.position.copy(this.defaultPositionCamera);
    this.scene.add(this.instance);

      // Debug
      if (this.debug.active) {

        this.debugFolder
          .add(this.instance.position, "x")
          .name("position x")
          .min(-5)
          .max(10)
          .step(0.001);
  
        this.debugFolder
          .add(this.instance.position, "y")
          .name("position y")
          .min(-5)
          .max(10)
          .step(0.001);
          this.debugFolder
          .add(this.instance.position, "z")
          .name("position z")
          .min(-5)
          .max(10)
          .step(0.001);
      }
  }

  // View 2d
  setOrthographic() {
    const aspect = this.sizes.width / this.sizes.height;
    const frustumSize = 9; 

    this.orthographic = new THREE.OrthographicCamera(
      (-frustumSize * aspect) / 2, 
      (frustumSize * aspect) / 2,
      frustumSize / 2, 
      -frustumSize / 2, 
      0.1, 
      100 
    );
    this.orthographic.position.set(0, 10, 0); // Position pour une vue de dessus
    this.orthographic.lookAt(new THREE.Vector3(0, 0, 0)); // Regarde la scène
    this.scene.add(this.orthographic);
  }

  setControls() {
    this.controls = new OrbitControls(this.instance, this.canvas);
    this.controls.enableDamping = false;
    this.controls.maxPolarAngle = Math.PI / 2 - 0.2;
    this.controls.minPolarAngle = -1;
    this.controls.maxDistance = 10; // max dezoom
    this.controls.minDistance = 3; // max zoom
    this.controls.rotateSpeed = 0.3; // sensibility
  
  }

  resize() {
    this.instance.aspect = this.sizes.width / this.sizes.height;
    this.instance.updateProjectionMatrix();

    const aspect = this.sizes.width / this.sizes.height;
    const frustumSize = 10;
    this.orthographic.left = (-frustumSize * aspect) / 2;
    this.orthographic.right = (frustumSize * aspect) / 2;
    this.orthographic.top = frustumSize / 2;
    this.orthographic.bottom = -frustumSize / 2;
    this.orthographic.updateProjectionMatrix();
  }

  update() {
    this.controls.update();
  }

  // Toggle Views (3d & 2d)
  toggleViews() {
    this.is2DView = !this.is2DView;

    if (this.is2DView) {
      this.instance.visible = false; // Cache la caméra 3D (perspective)
      this.orthographic.visible = true; // Affiche la caméra 2D (orthographique)
    } else {
      this.instance.visible = true; // Affiche la caméra 3D (perspective)
      this.orthographic.visible = false; // Cache la caméra 2D (orthographique)
      this.instance.position.copy(this.defaultPositionCamera);
    }
  }
}
